import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["WildcardRootContent"] */ "/app/src/app/[lng]/[cityCountryActivity]/content.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/home/home.css");
